import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'popover',
  templateUrl: './popover.component.html',
  styleUrls: ['./popover.component.scss'],
})
export class PopoverComponent implements OnInit {
  @Input() title = '';
  @Input() msg: string;
  @Input() msg2: string;
  @Input() msg3: string;
  @Input() msg4: string;

  ngOnInit(): void {}
}
